(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Mobile only: below 990px. Nothing loads or plays at 990px and up.
    var mobile = window.matchMedia('(max-width: 989px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var instances = [];

    function postToFrame(state, command) {
      var frame = state.frame;
      if (!frame || !frame.contentWindow || !frame.getAttribute('src')) return;
      if (state.kind === 'youtube') {
        frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command === 'play' ? 'playVideo' : 'pauseVideo', args: [] }), 'https://www.youtube.com');
      } else if (state.kind === 'vimeo') {
        frame.contentWindow.postMessage(JSON.stringify({ method: command }), 'https://player.vimeo.com');
      }
    }

    function attach(state) {
      if (state.attached) return;
      state.attached = true;
      if (state.kind === 'native') {
        state.video.src = state.video.dataset.src;
        state.video.preload = 'auto';
        state.video.load();
      } else if (state.frame) {
        var src = state.frame.dataset.src;
        if (state.userPaused) src = src.replace('autoplay=1', 'autoplay=0');
        state.frame.addEventListener('load', function () { update(state); });
        state.frame.src = src;
      }
    }

    function detach(state) {
      if (!state.attached) return;
      state.attached = false;
      if (state.kind === 'native') {
        state.video.pause();
        state.video.removeAttribute('src');
        state.video.load();
      } else if (state.frame) {
        state.frame.removeAttribute('src');
      }
    }

    function update(state) {
      if (!mobile.matches) {
        detach(state);
        return;
      }
      if (state.visible) attach(state);
      if (!state.attached) return;
      var shouldPlay = state.visible && !state.userPaused;
      if (state.kind === 'native') {
        if (shouldPlay) {
          var playing = state.video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          state.video.pause();
        }
      } else {
        postToFrame(state, shouldPlay ? 'play' : 'pause');
      }
    }

    function setButton(state) {
      if (!state.button) return;
      state.button.dataset.state = state.userPaused ? 'paused' : 'playing';
      state.button.setAttribute('aria-label', state.userPaused ? 'Play video' : 'Pause video');
    }

    // Text never spills out of a tile: long headings already wrap; if the wrapped text is still
    // taller than the tile (big size on a short tile), step every text size down until it fits.
    function fitText(root) {
      root.querySelectorAll('.msh__layer:not(.msh__layer--button)').forEach(function (layer) {
        var text = layer.querySelector('.msh__text');
        if (!text) return;
        var items = text.querySelectorAll('.msh__eyebrow, .msh__heading, .msh__sub');
        items.forEach(function (el) {
          if (el.dataset.mshSize) el.style.fontSize = el.dataset.mshSize;
          else el.dataset.mshSize = el.style.fontSize;
        });
        var available = layer.clientHeight - 32;
        var guard = 0;
        while (text.scrollHeight > available && guard < 40) {
          guard++;
          var shrunk = false;
          items.forEach(function (el) {
            var size = parseFloat(el.style.fontSize);
            if (size > 10) { el.style.fontSize = (size * 0.94).toFixed(1) + 'px'; shrunk = true; }
          });
          if (!shrunk) break;
        }
      });
    }

    function init(root) {
      if (!root || root.__msh) return;
      if (mobile.matches) fitText(root);
      if ('ResizeObserver' in window) {
        var resizeQueued = false;
        new ResizeObserver(function () {
          if (resizeQueued || !mobile.matches) return;
          resizeQueued = true;
          requestAnimationFrame(function () { resizeQueued = false; fitText(root); });
        }).observe(root);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (mobile.matches) fitText(root); });
      var states = [];
      var observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var state = entry.target.__mshState;
              if (!state) return;
              state.visible = entry.isIntersecting;
              update(state);
            });
          }, { rootMargin: '100px 0px', threshold: 0.15 })
        : null;

      root.querySelectorAll('[data-msh-video]').forEach(function (tile) {
        var state = {
          tile: tile,
          kind: tile.getAttribute('data-msh-video'),
          video: tile.querySelector('video'),
          frame: tile.querySelector('iframe'),
          button: tile.querySelector('[data-msh-toggle]'),
          visible: !observer,
          attached: false,
          userPaused: reducedMotion.matches
        };
        tile.__mshState = state;
        states.push(state);
        setButton(state);
        if (state.button) {
          state.button.addEventListener('click', function (event) {
            // Never let the pause/play tap reach the tile link.
            event.preventDefault();
            event.stopPropagation();
            state.userPaused = !state.userPaused;
            setButton(state);
            update(state);
          });
        }
        if (observer) observer.observe(tile);
        update(state);
      });

      root.__msh = {
        states: states,
        destroy: function () {
          if (observer) observer.disconnect();
          states.forEach(detach);
        }
      };
      instances.push(root);
    }

    function destroy(root) {
      if (!root || !root.__msh) return;
      root.__msh.destroy();
      root.__msh = null;
      instances = instances.filter(function (item) { return item !== root; });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-msh]').forEach(init);
    }

    function onViewportChange() {
      instances.forEach(function (root) {
        if (root.__msh) root.__msh.states.forEach(update);
      });
    }
    if (mobile.addEventListener) mobile.addEventListener('change', onViewportChange);
    else if (mobile.addListener) mobile.addListener(onViewportChange);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // Theme editor: re-rendered when tiles are added, removed, reordered or edited.
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-msh]').forEach(destroy);
    });
    document.addEventListener('shopify:block:select', function (event) {
      var tile = event.target.closest && event.target.closest('[data-msh-video]');
      if (tile && tile.__mshState) {
        tile.__mshState.visible = true;
        update(tile.__mshState);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-mosaic-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var desktop = window.matchMedia('(min-width: 990px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var instances = [];

    function postToFrame(state, command) {
      var frame = state.frame;
      if (!frame || !frame.contentWindow || !frame.getAttribute('src')) return;
      if (state.kind === 'youtube') {
        frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command === 'play' ? 'playVideo' : 'pauseVideo', args: [] }), 'https://www.youtube.com');
      } else if (state.kind === 'vimeo') {
        frame.contentWindow.postMessage(JSON.stringify({ method: command }), 'https://player.vimeo.com');
      }
    }

    // Load the video only on 990px+ screens, the first time the tile comes near the viewport.
    function attach(state) {
      if (state.attached) return;
      state.attached = true;
      if (state.kind === 'native') {
        state.video.src = state.video.dataset.src;
        state.video.preload = 'auto';
        state.video.load();
      } else if (state.frame) {
        var src = state.frame.dataset.src;
        if (state.userPaused) src = src.replace('autoplay=1', 'autoplay=0');
        state.frame.addEventListener('load', function () { update(state); });
        state.frame.src = src;
      }
    }

    function detach(state) {
      if (!state.attached) return;
      state.attached = false;
      if (state.kind === 'native') {
        state.video.pause();
        state.video.removeAttribute('src');
        state.video.load();
      } else if (state.frame) {
        state.frame.removeAttribute('src');
      }
    }

    function update(state) {
      if (!desktop.matches) {
        detach(state);
        return;
      }
      if (state.visible) attach(state);
      if (!state.attached) return;
      var shouldPlay = state.visible && !state.userPaused;
      if (state.kind === 'native') {
        if (shouldPlay) {
          var playing = state.video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          state.video.pause();
        }
      } else {
        postToFrame(state, shouldPlay ? 'play' : 'pause');
      }
    }

    function setButton(state) {
      if (!state.button) return;
      state.button.dataset.state = state.userPaused ? 'paused' : 'playing';
      state.button.setAttribute('aria-label', state.userPaused ? 'Play video' : 'Pause video');
    }

    function init(root) {
      if (!root || root.__pmb) return;
      var states = [];
      var observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var state = entry.target.__pmbState;
              if (!state) return;
              state.visible = entry.isIntersecting;
              update(state);
            });
          }, { rootMargin: '150px 0px', threshold: 0.1 })
        : null;

      root.querySelectorAll('[data-pmb-video]').forEach(function (tile) {
        var state = {
          tile: tile,
          kind: tile.getAttribute('data-pmb-video'),
          video: tile.querySelector('video'),
          frame: tile.querySelector('iframe'),
          button: tile.querySelector('[data-pmb-toggle]'),
          visible: !observer,
          attached: false,
          userPaused: reducedMotion.matches
        };
        tile.__pmbState = state;
        states.push(state);
        setButton(state);
        if (state.button) {
          state.button.addEventListener('click', function () {
            state.userPaused = !state.userPaused;
            setButton(state);
            update(state);
          });
        }
        if (observer) observer.observe(tile);
        update(state);
      });

      root.__pmb = {
        states: states,
        destroy: function () {
          if (observer) observer.disconnect();
          states.forEach(detach);
        }
      };
      instances.push(root);
    }

    function destroy(root) {
      if (!root || !root.__pmb) return;
      root.__pmb.destroy();
      root.__pmb = null;
      instances = instances.filter(function (item) { return item !== root; });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-pmb]').forEach(init);
    }

    function onViewportChange() {
      instances.forEach(function (root) {
        if (root.__pmb) root.__pmb.states.forEach(update);
      });
    }
    if (desktop.addEventListener) {
      desktop.addEventListener('change', onViewportChange);
    } else if (desktop.addListener) {
      desktop.addListener(onViewportChange);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // Theme editor: sections re-render when blocks are added, removed, reordered or edited.
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-pmb]').forEach(destroy);
    });
    document.addEventListener('shopify:block:select', function (event) {
      var tile = event.target.closest && event.target.closest('[data-pmb-video]');
      if (tile && tile.__pmbState) {
        tile.__pmbState.visible = true;
        update(tile.__pmbState);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Menu columns collapse into tap-to-open rows on mobile (the toggle is hidden on desktop).
    // The About block's See More / See Less is the site-wide one (assets/rv-see-more.js).
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-rv-menu-toggle]');
      if (!toggle) return;
      var menu = toggle.closest('[data-rv-menu]');
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });

    // Chat With Us: opens the Radiance Veil chat (snippets/rv-chat.liquid, assets/rv-support.js).
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-rv-chat]');
      if (!link || !window.rvChat) return;
      event.preventDefault();
      window.rvChat.open();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
